export default "__VITE_ASSET__dm77mtX2__"